module.exports = __webpack_public_path__ + "images/stickers/pete-alert.90e3c39fb39d5d79e8e2.png";